import React, { useEffect, useState } from "react";
import { Modal, Button, Spinner, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import moment from "moment";
import { setCDRAiTagRequestData, setCDRAvailableTags } from "../../../../_reducers/crmSlice";
import Input from "../../../common/Input";
import Dropdown from "../../../primer/Dropdown";

const AICDRTagsModal = ({ show, onHide }) => {
    const dispatch = useDispatch();
    const tagRequest = useSelector((state) => state.CRM.cdrAiTagRequestData);
    const availableTags = useSelector((state) => state.CRM.cdrAiTagResponseData);
    const [loading, setLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    const companyOptions = [
        { label: "Primer", value: "Primer" },
        { label: "Emron", value: "Emron" }
    ];

    useEffect(() => {
        if (show) {
            fetchTags();
        }
    }, [show]);

    const fetchTags = () => {
        setLoading(true);
        axios.get(`${process.env.REACT_APP_API_URL2}/ai/get-cdr-tags`)
            .then(res => {
                if (res.data.status === "200") {
                    dispatch(setCDRAvailableTags(res.data.data));
                }
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    };

    const handleInputChange = (e) => {
        dispatch(setCDRAiTagRequestData({ ...tagRequest, name: e.target.value }));
    };

    const handleOnChange = (e, type, ddname) => {
        if (type === "dropdown") {
            dispatch(setCDRAiTagRequestData({
                ...tagRequest,
                [ddname]: e.value
            }));
        }
    };

    const handleSaveTag = () => {
        if (!tagRequest.name || tagRequest.name.trim() === "") {
            return toast.warning("Παρακαλώ δώστε όνομα στο Tag.");
        }

        if (!tagRequest.forCompany || tagRequest.forCompany.trim() === "") {
            return toast.warning("Παρακαλώ επιλέξτε σε ποια εταιρεία ανήκει το Tag.");
        }

        setIsSaving(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/ai/add-cdr-tag`, {
            name: tagRequest.name.trim(),
            forCompany: tagRequest.forCompany
        })
            .then(res => {
                if (res.data.status === "200") {
                    toast.success("Το Tag αποθηκεύτηκε επιτυχώς.");
                    dispatch(setCDRAiTagRequestData({name: "", forCompany: ""}));
                    fetchTags();
                } else {
                    toast.error(res.data.message || "Σφάλμα κατά την αποθήκευση.");
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error("Αποτυχία σύνδεσης με τον διακομιστή.");
            })
            .finally(() => setIsSaving(false));
    };

    const handleDeleteTag = (id) => {
        axios.delete(`${process.env.REACT_APP_API_URL2}/ai/delete-cdr-tag/${id}`)
            .then(res => {
                if (res.data.status === "200") {
                    toast.success("Το Tag διαγράφηκε.");
                    fetchTags();
                } else {
                    toast.error(res.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error("Σφάλμα κατά τη διαγραφή.")
            });
    };

    const filteredTags = availableTags.filter(tag => {
        const term = searchTerm.toLowerCase();
        return (
            tag.name?.toLowerCase().includes(term) ||
            tag.forCompany?.toLowerCase().includes(term)
        );
    });

    return (
        <Modal show={show} onHide={onHide} centered scrollable dialogClassName="modal45PercentWidth" backdrop="static" >
            <Modal.Header closeButton>
                <Modal.Title className="d-flex align-items-center">
                    Διαχείριση AI Tags
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className="align-items-end mb-4">
                    <Col md={5} className={"mb-3"}>
                        <Input
                            label="Όνομα Νέου Tag"
                            name="tagName"
                            value={tagRequest.name}
                            onChange={handleInputChange}
                            placeholder="π.χ. Παράπονο Πελάτη"
                        />
                    </Col>
                    <Col md={3}>
                        <Dropdown
                            label={"Εταιρεία"}
                            name={"forCompany"}
                            options={companyOptions}
                            enabledValue={true}
                            value={companyOptions.find(opt => opt.value === tagRequest.forCompany)}
                            onChange={(e) => handleOnChange(e, "dropdown", "forCompany")}
                        />
                    </Col>
                    <Col md={4} className={"mb-3"}>
                        <Button
                            className="w-100"
                            onClick={handleSaveTag}
                            disabled={isSaving || tagRequest.name === "" || tagRequest.forCompany === ""}
                        >
                            {isSaving ? <Spinner animation="border" size="sm" /> : "Προσθήκη"}
                        </Button>
                    </Col>
                </Row>

                <Row className="align-items-start mb-2">
                    <Col md={2}>
                        <div className={"text-muted"}><i>Διαθέσιμα AI Tags</i></div>
                    </Col>
                    <Col md={6}>
                        <input
                            type="text"
                            className="form-control form-control-sm border-0 bg-transparent"
                            placeholder="Αναζήτηση με όνομα ή εταιρεία"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{ boxShadow: "none" }}
                        />
                    </Col>
                </Row>

                <div style={{ maxHeight: "500px", overflowY: "auto", marginTop: "3px" }}>
                    <table className="table-hover" style={{ tableLayout: "fixed", textAlign: "center", width: "100%" }}>
                        <colgroup>
                            <col style={{ width: "50px" }} />
                            <col style={{ width: "auto" }} />
                            <col style={{ width: "160px" }} />
                            <col style={{ width: "160px"}} />
                            <col style={{ width: "80px" }} />
                        </colgroup>
                        <thead style={{ position: "sticky", top: 0, backgroundColor: "white", zIndex: 10 }}>
                        <tr>
                            <th style={{ border: "1px solid gray", backgroundColor: "#f1fdff", padding: "8px" }}>Αρ.</th>
                            <th style={{ border: "1px solid gray", backgroundColor: "#f1fdff", padding: "8px" }}>Όνομα Tag</th>
                            <th style={{ border: "1px solid gray", backgroundColor: "#f1fdff", padding: "8px" }}>Εταιρεία</th>
                            <th style={{ border: "1px solid gray", backgroundColor: "#f1fdff", padding: "8px" }}>Ημ/νία Δημιουργίας</th>
                            <th style={{ border: "1px solid gray", backgroundColor: "#f1fdff", padding: "8px" }}>Ενέργειες</th>
                        </tr>
                        </thead>
                        <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan={4} className="py-4">
                                    <Spinner animation="border" variant="primary" size="sm" />
                                    <div className="mt-2 text-muted" style={{ fontSize: '12px' }}>Φόρτωση δεδομένων...</div>
                                </td>
                            </tr>
                        ) : filteredTags.length > 0 ? (
                            filteredTags.map((tag, index) => (
                                <tr key={tag._id || index}>
                                    <td style={{ border: "1px solid gray", padding: "6px" }}>{index + 1}</td>
                                    <td
                                        className="text-left px-3"
                                        style={{
                                            border: "1px solid gray",
                                            padding: "6px",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        }}
                                        title={tag.name}
                                    >
                                        {tag.name}
                                    </td>
                                    <td style={{ border: "1px solid gray", padding: "6px", fontSize: "13px" }}>{tag.forCompany}</td>
                                    <td style={{ border: "1px solid gray", padding: "6px", fontSize: "13px" }}>
                                        {moment(tag.created_at).format("DD/MM/YYYY HH:mm")}
                                    </td>
                                    <td style={{ border: "1px solid gray", padding: "2px" }}>
                                        <Button
                                            variant="outline-danger"
                                            size="sm"
                                            style={{ padding: "5px 8px" }}
                                            onClick={() => handleDeleteTag(tag._id)}
                                            title="Διαγραφή"
                                        >
                                            <i className="fa fa-trash"></i>
                                        </Button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={5} className="py-2 text-muted" style={{ border: "1px solid gray", backgroundColor: "#fcfcfc" }}>
                                    {searchTerm ? "Δεν βρέθηκαν αποτελέσματα" : "Δεν υπάρχουν διαθέσιμα Tags"}
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default AICDRTagsModal;